module.exports = __webpack_public_path__ + "img/hezuojigou.d0ea7075.png";